import styled from 'styled-components';
import { Modal } from 'antd';


export const StyledModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 0px;
		border: 2px solid ${(props) => props.theme.colors.fallow};
	}

	.ant-modal-header {
		border-bottom: none;
		padding-bottom: 0px;
	}

	.ant-modal-title {
		font-size: 1.2rem;
	}

	.ant-modal-body .anticon {
		color: ${({ theme }) => theme.colors.fallow};
	}
`;

export const ModalTextParagraph = styled.p`
	font-size: 1rem;

	span {
		display: block;
	}
`;